import { Route, Routes, Navigate } from 'react-router-dom';
import { ConsiderRegisterDetailPage } from "../../pages/RegisterSystem/ConsiderRegisterDetailPage";
import { ConsiderRegisterPage } from "../../pages/RegisterSystem/ConsiderRegisterPage";
import { ConsiderProfilePage } from '../../pages/RegisterSystem/ConsiderProfilePage';
import { ConsiderProfileDetailPage } from '../../pages/RegisterSystem/ConsiderProfileDetailPage';
export function AppReq() {
    return (

        <Routes>
            <Route
                path="/"
                element={<ConsiderRegisterPage />}
            />
            <Route
                path="/check"
                element={<ConsiderRegisterDetailPage />}

            />
             <Route
                path="/consider-profile"
                element={<ConsiderProfilePage />}

            />
             <Route
                path="/profile-detail"
                element={<ConsiderProfileDetailPage />}

            />

            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>

    );

}